/* index.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./index.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React, { useRef } from 'react';
var pulseKeyframes = null;
var pulseStyles = null;
var commonStyles = null;
export var Pulse = function Pulse(_ref) {
  var children = _ref.children,
    _ref$showPulse = _ref.showPulse,
    showPulse = _ref$showPulse === void 0 ? false : _ref$showPulse,
    onAnimationIteration = _ref.onAnimationIteration,
    onAnimationStart = _ref.onAnimationStart,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? 'discovery-pulse' : _ref$testId;
  // this ref is to persist the animation through rerenders
  var pulseStarted = useRef(false);
  if (showPulse) {
    pulseStarted.current = true;
  }
  var stopPropagation = React.useCallback(function (e) {
    e.stopPropagation();
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": testId,
    onAnimationIteration: onAnimationIteration,
    onAnimationStart: onAnimationStart,
    className: ax(["_1e0c1nu9", pulseStarted.current && "_2rko1l7b _y44vrp0f _16qsat0y"]),
    style: {
      "--_1o6m8uc": ix("0 0 0 0 ".concat("var(--ds-background-discovery-bold, #5243AA)")),
      "--_bp628": ix("".concat(pulseKeyframes, " 1.45s cubic-bezier(0.5, 0, 0, 1) 3"))
    }
  }, /*#__PURE__*/React.createElement("span", {
    onAnimationIteration: stopPropagation,
    onAnimationStart: stopPropagation
  }, children));
};
export default Pulse;